import { Input } from 'antd';
import { Row } from 'farmhub-ui-core';
import styled from 'styled-components';

export const DesktopWrapper = styled(Input)<{
  background?: string;
  width: number;
  height?: number | string;
}>`
  height: ${p =>
    p.height != undefined
      ? typeof p.height === 'string'
        ? p.height
        : `${p.height}px`
      : `${p.theme.input.height.md}`};
  background: ${p => p.background} !important;
  width: ${p => p.width}px;
  .ant-input {
    background: ${p => p.background || '#fafafa'};

    &::placeholder {
      font-size: ${props => props.theme.font.size.xs} !important;
      color: ${props => props.theme.colors.text.secondary};
    }
  }
`;

export const FilterDesktopWrapper = styled(Row)`
  .ant-input-affix-wrapper {
    border-radius: 0px 6px 6px 0px !important;
    margin-left: -1px !important;
  }
`;

export const SelectDesktopWrapper = styled.div`
  position: relative;
  z-index: 1;
  .ant-select-selector {
    border-radius: 6px 0px 0px 6px !important;
  }
`;

export const PopupRow = styled(Row)`
  height: ${p => p.theme.select.height.lg};
  padding: ${p => p.theme.app.padding.horizontal};
`;

export const MobileWrapper = styled(Input)<{
  background?: string;
  height?: number | string;
}>`
  height: ${p =>
    p.height != undefined
      ? typeof p.height === 'string'
        ? p.height
        : `${p.height}px`
      : `${p.theme.input.height.md}`};
  background: ${p => p.background} !important;
  width: 100%;
  .ant-input {
    background: ${p => p.background || '#fafafa'};

    &::placeholder {
      font-size: ${props => props.theme.font.size.xs} !important;
      color: ${props => props.theme.colors.text.secondary};
    }
  }
`;

export const FilterMobileWrapper = styled(Row)`
  .ant-input-affix-wrapper {
    border-radius: 0px 6px 6px 0px !important;
    margin-left: -1px !important;
  }
`;

export const SelectMobileWrapper = styled.div`
  width: 100%;
  position: relative;
  z-index: 1;
  .ant-select-selector {
    border-radius: 6px 0px 0px 6px !important;
  }
`;

export const SelectEntityTypeWrapper = styled(Row)`
  width: fit-content;
  border-radius: ${p => p.theme.radius.md} 0px 0px ${p => p.theme.radius.md};
  padding: 0px ${p => p.theme.app.padding.vertical};
  height: ${p => p.theme.select.height.sm};
  border: 1px solid ${p => p.theme.colors.border.main};
`;

export const WrapperMobile = styled.div<{ active: boolean }>`
  width: 100%;
  padding: ${p => p.theme.app.padding.vertical}
    ${p => p.theme.app.padding.horizontal} !important;
  position: relative;

  cursor: pointer;

  transition: all 0.4s;

  &:hover {
    &::before {
      content: ' ';
      width: 100%;
      height: 100%;
      border-radius: ${props => props.theme.radius.md};
      background: ${props => props.theme.colors.primary.main} !important;
      opacity: 0.1;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  ${props =>
    props.active
      ? `&::before {
      content: ' ';
      width: 100%;
      height: 100%;
      background: ${props.theme.colors.primary.main} !important;
      opacity: 0.1;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
    };
    svg{
    z-index: 1;
    fill: ${props.theme.colors.primary.main} !important;
    }
    
    `
      : ''}
`;
